import BusinessNotification from './BusinessNotification.jsx';

export {
  BusinessNotification
}


// WEBPACK FOOTER //
// ./components/users/sub-view/the-news/notification/index.js